<template>
    <Loading v-bind:show="showLoading">
        <PageTitle title="Quadro de Horário - Sala Normal" />
        <md-dialog :md-active.sync="showInserirDisciplina">
            <md-dialog-title><md-icon>article</md-icon> Incluir Disciplina</md-dialog-title>
            <md-content>
                <form novalidate class="md-layout" style="min-width: 500px;">
                    <md-card class="md-layout-item md-size-100 md-small-size-100">
                        <md-card-content>
                            <md-field>
                                <label for="disciplina"> Disciplina</label>
                                <md-select v-model="disciplina" name="disciplina" id="disciplina" @md-selected="carregaDisciplinasEquivalentes" class="filtro" style="color:#6361FB !important">
                                    <md-option :value="0" :key="0"></md-option>
                                    <md-option :value="c.codigoDisciplina" v-for="c in dadosDisciplinas" :key="c.codigoDisciplina">
                                        {{c.disciplina}}
                                    </md-option>
                                </md-select>
                            </md-field>
                            <md-field v-if="disciplina && ! dadosDisciplinasEquivalentes">
                                <label><md-icon>loop</md-icon> Carregando ...</label>
                            </md-field>
                            <md-field v-if="dadosDisciplinasEquivalentes !== null">
                                <label for="disciplinaEquivalente"> Disciplina Equivalente</label>
                                <md-select v-model="disciplinaEquivalente" name="disciplinaEquivalente" id="disciplinaEquivalente" class="filtro" style="color:#6361FB !important">
                                    <md-option :value="0" :key="0"></md-option>
                                    <md-option :value="c.codigoDisciplina" v-for="c in dadosDisciplinasEquivalentes" :key="c.codigoDisciplina">
                                        {{c.disciplina}}
                                    </md-option>
                                </md-select>
                            </md-field>
                        </md-card-content>

                        <md-card-actions>
                            <md-button class="md-primary" @click="showInserirDisciplina = false">Cancelar</md-button>
                            <md-button class="md-primary" @click="inserirDisciplinaAluno()" v-if="disciplinaEquivalente !== 0">Salvar</md-button>
                        </md-card-actions>
                    </md-card>
                </form>
            </md-content>
        </md-dialog>
        <div v-if="dadosAba">
            <div v-if="$featureToggle && $featureToggle.INTEGRA_QUADROHORARIO_SALASNORMAIS">

                <div class="md-layout" style=" margin-top: 23px;">



                    <div class="md-layout-item first-layout md-size-40">
                        <p class="titulo s-h2">
                            Carga Horária {{periodoFormatado()}}
                            <md-icon v-if="periodoBloqueado" class="lock-icon" style="margin-right: 9px;">lock</md-icon>
                        </p>
                        <Info Titulo=""
                              class="horario-info"
                              v-bind:Informacao="dadosAba.quadroHorario.cargaHoraria.chTurma.toString() + 'h'"
                              Descricao="CURSADA"
                              BordaCor="6361fb"
                              Tipo="texto" />

                        <Info Titulo=""
                              class="horario-info"
                              v-bind:Informacao="dadosAba.quadroHorario.cargaHoraria.chMinima.toString() + 'h'"
                              Descricao="MÍNIMA"
                              BordaCor="ffad42"
                              Tipo="texto" />

                        <Info Titulo=""
                              class="horario-info"
                              v-bind:Informacao="dadosAba.quadroHorario.cargaHoraria.chContratada.toString() + 'h' "
                              Descricao="CONTRATADA"
                              BordaCor="009688"
                              Tipo="texto" />
                    </div>

                    <div class="md-layout-item md-size-20 center-align">
                        <Label :text="dadosAba.quadroHorario.semestralizado.descricao" :theme="semestralizado.theme" icon="" class="button-116-wide semestralizado s-h3" />

                        <md-menu md-size="auto" class="button-like-extended white">
                            <md-button md-menu-trigger class="button-periodo">
                                Período
                                <md-icon style="margin-right: 9px;">expand_less</md-icon>
                            </md-button>

                            <md-menu-content class="periodo-wide">
                                <md-menu-item style="background:#FFFFFF" v-for="c in dadosAba.periodo.dados" :value="c.value" @click="carregaQuadroHorario(c.value)" :key="c.value">{{formatarPeriodoParaExibicao(c.text)}}</md-menu-item>
                            </md-menu-content>
                        </md-menu>
                    </div>







                    <div class="md-layout-item md-size-20 center-align">
                        <span class="s-h4 confirmation-label" style=" margin-bottom: -6px;">Confirmação de Horário</span>
                        <spanspan class="s-h4 confirmation-label regular" style="white-space:nowrap">{{ dadosAba.quadroHorario.confirmacaoHorario}}</spanspan>
                        <md-button class="md-raised md-dense md-primary" v-if="exibirBtnInserirDisciplinas && !dadosDisciplinas">
                            <md-icon>loop</md-icon> Aguarde ...
                        </md-button>
                        <md-button class="md-raised md-dense md-primary button-incluir-dis botao-base-quadro robold" @click="carregaModalInserirDisciplinas" :disabled="!dadosDisciplinas || !exibirBtnInserirDisciplinas || periodoBloqueado">
                            <md-icon style="font-size: 15px !important; font-weight: 400;">playlist_add</md-icon>Incluir Disciplina
                        </md-button>

                    </div>



                    <div class="md-layout-item md-size-20 center-align">

                        <div>
                            <md-button v-if="dadosAba.quadroHorario.situacao === 'A'" class="md-dense md-raised md-primary button-conf-hor botao-base-quadro" :disabled="periodoBloqueado" @click="modalConfirmarHorario">Confirmar horário</md-button>
                            <md-button v-else-if="dadosAba.quadroHorario.situacao === 'C'" class="md-dense md-raised md-accent button-conf-hor botao-base-quadro" :disabled="periodoBloqueado" style="display:initial" @click="modalDesconfirmarHorario">Retirar Confirmação</md-button>
                            <span></span>
                        </div>


                        <md-button class="md-raised md-dense md-primary" v-if="exibirBtnInserirDisciplinas && !dadosDisciplinas">
                            <md-icon>loop</md-icon> Aguarde ...
                        </md-button>

                        <md-button class="md-primary buttonHistoricoAceite botao-base-quadro" v-on:click="carregarHistoricoAceite"><md-icon class="iconeHistoricoAceite">history</md-icon>HIST. DE ACEITE</md-button>
                    </div>
                </div>

                <div style="clear: both; margin-top: 10px;"></div>

                <Grid v-bind:Data="dadosAba.quadroHorario.disciplinas"
                      v-bind:Header="headerSalaNormal"
                      Name="SalaNormal"
                      Title="Total"
                      OrderBy="turma"
                      v-bind:HeaderDetalhes="headerDetalhe"
                      v-bind:DetalhesCombo1="dadosAba.tipoDisciplina"
                      v-bind:DetalhesCombo2="dadosAba.situacao"
                      v-bind:DetalhesCombo3="null" />
            </div>

            <md-dialog :md-active.sync="exibirHistoricoAceite" class="divHistoricoAceite">
                <h2>Histórico de Aceite</h2>

                <Grid v-bind:Data="dadosAba.quadroHorario.historicoAceite"
                      v-bind:Header="headerHistoricoAceite"
                      Name="HistoricoAceite"
                      Title="Total"
                      OrderBy="periodoLetivo"
                      v-bind:HeaderDetalhes="null"
                      v-bind:DetalhesCombo1="null"
                      v-bind:DetalhesCombo2="null"
                      v-bind:DetalhesCombo3="null" />

                <md-dialog-actions>
                    <md-button class="md-primary" @click="carregarHistoricoAceite">Fechar</md-button>
                </md-dialog-actions>
            </md-dialog>
        </div>
    </Loading>
</template>

<script>
    import Grid from '@/components/Grid';
    import Enturmacao from '@/services/EnturmacaoService.js';
    import QuadroHorario from '@/services/QuadroHorarioService.js';
    import Loading from '@/components/Loading';
    import Info from '@/components/Info';
    import Label from '@/components/Label';
    import PageTitle from '@/components/PageTitle';

    export default {
        name: 'QuadroHorarioSalaNormal',
        components: {
            Grid,
            Loading,
            Info,
            Label,
            PageTitle
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.QuadroHorarioSalaNormal) {
                        this.dadosAba = a.QuadroHorario;
                    }
                }
                else
                    this.$router.push('home');
            }

            this.quadroHorarioService = new QuadroHorario(this);

            //Verifica se a aba não está carregada
            if (!this.dadosAba) {
                //Popula os dados da aba
                this.carregaQuadroHorario();

            }

            this.enturmacaoService = new Enturmacao(this);
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.QuadroHorarioSalaNormal = this.dadosAba;
            sessionStorage.setItem("QuadroHorario", JSON.stringify(aluno));
        },
        props: {
            DetalhesDisciplinas: {
                type: Object
            }
        },
        data() {
            return {
                expandPrincipal: true,
                expandInfo: true,
                aluno: null,
                showLoading: false,
                exibirCombo1: false,
                headerSalaNormal: [
                    {
                        Titulo: "Disciplina",
                        Field: "descricaoCompleta",
                        Width: "200px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Tipo Disciplina",
                        Field: "tipoDisciplina",
                        Width: "80px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Carga Horária",
                        Field: "cargaHoraria",
                        Width: "60px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Série",
                        Field: "serie",
                        Width: "60px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Turma",
                        Field: "turma",
                        Width: "80px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Situação",
                        Field: "situacaoAlunoDisciplinaDescricao",
                        Width: "80px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Remover",
                        Field: "remover",
                        Width: "20px",
                        Tipo: "remove-button"
                    }
                ],

                headerDetalhe: [
                    {
                        Titulo: "Horário de aula",
                        Field: "descricaoHorarioAgrupadoPorDia",
                        Tipo: "texto"
                    }
                ],

                headerHistoricoAceite: [
                    {
                        Titulo: "Período",
                        Field: "periodoLetivo",
                        Width: "80px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Data/Hora",
                        Field: "dataHora",
                        Width: "80px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Usuário",
                        Field: "usuario",
                        Width: "150px",
                        Tipo: "texto"
                    }
                    ,
                    {
                        Titulo: "Justificativa",
                        Field: "justificativa",
                        Width: "400px",
                        Tipo: "texto"
                    }
                ],

                dadosAba: null,
                salaNormalClasse: 'md-raised md-primary',
                semestralizado: null,
                exibirHistoricoAceite: false,
                disciplina: '',
                disciplinaEquivalente: '',
                dadosDisciplinas: null,
                dadosDisciplinasEquivalentes: null,
                showInserirDisciplina: false,
                exibirBtnInserirDisciplinas: false,
                exibirBtnExcluirDisciplina: false
            }
        },
        methods: {
            teste(a) {
                console.log(a);
            },
            periodoFormatado() {
                if (this.dadosAba?.quadroHorario?.historicoAceite?.length) {
                    return "- " + this.formatarPeriodoParaExibicao(this.dadosAba.quadroHorario.historicoAceite[0].periodoLetivo);
                }
            },

            formatarPeriodoParaExibicao(periodonum) {
                //#periodonum 2020.1
                if (typeof periodonum == 'string') {
                    return periodonum.substring(0, 4) + "." + periodonum.substring(4);
                } else if (typeof periodonum == 'number') {
                    let str = periodonum.toString();
                    return str.substring(0, 4) + "." + str.substring(4);
                } else {
                    return periodonum;
                }

            },

            removerPeriodoTodos() {
                if (this.dadosAba.periodo?.dados) {
                    let todos = this.dadosAba.periodo.dados.find(t => t.value == "Todos");
                    let index = this.dadosAba.periodo.dados.indexOf(todos);
                    if (index > -1) {
                        this.dadosAba.periodo.dados.splice(index, 1);
                    }
                }
            },

            carregarHistoricoAceite() {
                this.exibirHistoricoAceite = !this.exibirHistoricoAceite;
            },

            semestralizadoDetalhes() {
                switch (this.dadosAba.quadroHorario.semestralizado.codigo) {
                    case "NOR": this.semestralizado = { theme: 'primary' }; break; //Cursando
                    default: this.semestralizado = { theme: 'warning' }; break;
                }
            },

            modalConfirmarHorario() {
                this.$modal.confirm("Deseja realizar a confirmação de horário do aluno?", this.confirmarHorario)
            },

            carregaQuadroHorario(periodo) {
                this.showLoading = true;
                this.quadroHorarioService.ObterQuadroHorarioAluno({
                    CodigoAluno: this.aluno.codigoAluno,
                    CodigoEspecialidade: this.aluno.codigoEspecialidade,
                    CodigoPeriodo: periodo ? periodo : this.aluno.codigoPeriodoSituacao,
                    CodigoEmpresa: this.aluno.codigoEmpresa,
                    CodigoTurma: this.aluno.codigoTurma
                }).then(
                    data => {
                        if (data.ok) {
                            this.dadosAba = data.dados;
                            this.removerPeriodoTodos();
                            if (this.dadosAba.quadroHorario.situacao === 'A' && this.aluno.codigoEmpresa == 1) {
                                this.detalhesDisciplinas = this.carregaDisciplinas();
                                this.exibirDisciplinas = true;
                                this.exibirBtnInserirDisciplinas = true;
                                this.exibirBtnExcluirDisciplina = true;
                            } else {
                                this.headerSalaNormal.splice(6, 1); // Coluna Remover Disciplina
                            }
                            this.semestralizadoDetalhes();
                        }
                        else {
                            this.$modal.info(data.Mensagem);
                        }
                    },
                    error => {
                        if (error.status != 500)
                            this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        else
                            this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                    }).finally(() => {
                        this.showLoading = false;
                    });
            },

            confirmarHorario() {
                this.showLoading = true;
                this.quadroHorarioService.ConfirmacaoHorarioAluno({
                    CodigoAluno: this.aluno.codigoAluno,
                    CodigoEspecialidade: this.aluno.codigoEspecialidade,
                    CodigoPeriodo: this.aluno.codigoPeriodoSituacao,
                    CodigoEmpresa: this.aluno.codigoEmpresa,
                    CodigoRequisicao: null
                }).then(
                    data => {
                        if (data.ok) {
                            this.carregaQuadroHorario();
                            this.$modal.info(data.mensagem);
                        }
                        else {
                            this.$modal.alert(data.Mensagem, data.dados);
                        }
                    },
                    error => {
                        if (error.status != 500)
                            this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        else
                            this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                    }).finally(() => {
                        this.showLoading = false;
                    });
            },

            modalDesconfirmarHorario() {
                this.$modal.confirm("Deseja retirar a confirmação de horário do aluno?", this.desconfirmarHorario)
            },

            desconfirmarHorario() {
                this.showLoading = true;
                this.quadroHorarioService.DesconfirmacaoHorarioAluno({
                    CodigoAluno: this.aluno.codigoAluno,
                    CodigoEspecialidade: this.aluno.codigoEspecialidade,
                    CodigoPeriodo: this.aluno.codigoPeriodoSituacao,
                    CodigoEmpresa: this.aluno.codigoEmpresa,
                    CodigoRequisicao: null
                }).then(
                    data => {
                        console.log(data)
                        if (data.ok) {
                            this.carregaQuadroHorario();
                            this.$modal.info(data.mensagem);
                        }
                        else {
                            this.$modal.alert(data.Mensagem, data.Dados);
                        }
                    },
                    error => {
                        if (error.status != 500)
                            this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        else
                            this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                    }).finally(() => {
                        this.showLoading = false;
                    });
            },

            carregaModalInserirDisciplinas() {
                this.disciplina = 0;
                this.disciplinaEquivalente = 0;
                this.dadosDisciplinasEquivalentes = null;
                this.showInserirDisciplina = true
            },

            carregaDisciplinas() {
                this.enturmacaoService.ListarDisciplinasDoAluno({
                    CodigoAluno: this.aluno.codigoAluno,
                    CodigoEspecialidade: this.aluno.codigoEspecialidade,
                    CodigoPeriodo: this.aluno.codigoPeriodoSituacao,
                    CodigoEmpresa: this.aluno.codigoEmpresa,
                    CodigoTurma: this.aluno.codigoTurma
                }).then(
                    data => {
                        if (data.ok) {
                            data = this.distinct(data.dados, 'codigoDisciplina');
                            this.dadosDisciplinas = data;
                        }
                        else {
                            this.$modal.info(data.Mensagem);
                        }
                    },
                    error => {
                        if (error.status != 500)
                            this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        else
                            this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                    }).finally(() => {
                        this.showLoading = false;
                    });
            },

            carregaDisciplinasEquivalentes() {
                this.dadosDisciplinasEquivalentes = null;
                this.disciplinaEquivalente = '';
                if (this.disciplina) {
                    this.enturmacaoService.ListarDisciplinaGradeEquivalente({
                        CodigoAluno: this.aluno.codigoAluno,
                        CodigoEspecialidade: this.aluno.codigoEspecialidade,
                        CodigoDisciplina: this.disciplina
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosDisciplinasEquivalentes = data.dados;
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoading = false;
                        });
                }
            },
            inserirDisciplinaAluno() {
                if (this.disciplina && this.disciplinaEquivalente) {
                    var disciplinaDados;
                    this.dadosDisciplinas.forEach(item => {
                        if (item.codigoDisciplina == this.disciplina) {
                            disciplinaDados = item;
                        }
                    });
                    var disciplinaEquivalenteDados;
                    this.dadosDisciplinasEquivalentes.forEach(item => {
                        if (item.codigoDisciplina == this.disciplinaEquivalente) {
                            disciplinaEquivalenteDados = item;
                        }
                    });
                    this.enturmacaoService.InserirDisciplina({
                        CodigoEmpresa: this.aluno.codigoEmpresa,
                        CodigoAluno: this.aluno.codigoAluno,
                        CodigoEspecialidade: this.aluno.codigoEspecialidade,
                        CodigoDisciplina: this.disciplina,
                        CodigoTurma: disciplinaDados.codigoTurma,
                        Dimtip: disciplinaDados.Dimtip,
                        CodigoPeriodo: this.aluno.codigoPeriodoSituacao,
                        RespeitaHorario: 'S',
                        DisCodeGrade: this.disciplinaEquivalente,
                        Extra: disciplinaDados.disExtra,
                        CodigoRequisicao: ''
                    }).then(
                        data => {
                            if (data.ok) {
                                this.$modal.info('Disciplina ' + disciplinaEquivalenteDados.disciplina + ' inserida com sucesso!');
                                this.carregaQuadroHorario();
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoading = false;
                        });
                }
            },
            distinct(array, key) {
                const result = {};
                const data = [];
                array.forEach(item => {
                    if (!result[item[key]]) {
                        result[item[key]] = [];
                        data.push(item);
                    }
                });
                return data;
            }
        },
        computed: {
            periodoBloqueado() {
                if (this.aluno?.codigoPeriodoSituacao &&
                    this.dadosAba?.quadroHorario?.historicoAceite[0]?.periodoLetivo) {
                    if (this.dadosAba?.quadroHorario?.historicoAceite[0]?.periodoLetivo != this.aluno.codigoPeriodoSituacao) {
                        return true;
                    }
                }
                return false
            }
        }
    }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



    .md-field {
        max-width: 100%;
        font-weight: bold;
    }

    .full-control {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap-reverse;
    }

    .list {
        width: 320px;
    }

    .titulo {
        margin: 0;
        padding: 0 0 0 15px;
        font-weight: bold;
    }


    .divHorario {
        float: left;
        position: relative;
        display: inline;
        width: 300px;
        padding: 0 10px 10px 10px;
    }

    .divCargaHoraria {
        width: 400px;
        float: left;
        position: relative;
        display: inline;
        padding: 0 0 0 30px
    }


    .divHistoricoAceite {
        z-index: 1000;
        width: 90%;
        height: 500px;
        overflow-y: auto;
        padding: 20px;
    }

    .buttonHistoricoAceite {
        /*background-color: #8629ff;
    border-radius: 5px;
    color: #fff;
    font-size: 13px;
    margin-top: 10px;
    padding: 10px;
    font-weight: bold;*/
        border: solid 1px;
        border-color: #8629ff !important;
        font-size: 80%;
        color: #4A89FC !important;
        background-color: transparent !important;
        margin-top: 0px;
        font-weight: bolder;
    }

    .iconeHistoricoAceite {
        color: #4A89FC !important;
        font-weight: 100;
        font-size: 18px !important;
    }

    .semestralizado {
        display: inline-block;
        width: 160px;
        margin-left: 1px;
        margin-bottom: 18px;
        padding-top: 0px;
        font-size: 12px;
        padding-left: 0;
    }

    .first-layout {
        margin-left: -14px;
    }

    .md-tab {
        padding: 0;
        margin: 0 !important;
    }

    .button-periodo {
        height: 40px
    }

    .filtro {
        height: 40px !important;
        font-size: 20px !important;
        min-width: 500px;
    }

    .botao-base-quadro {
        width: 168px !important;
        border-radius: 5px !important;
        height: 40px;
    }

    .button-conf-hor {
        margin-top: -3px;
    }

    .button-incluir-dis {
        font-size: 12px;
        margin-top: 8px;
    }

    .confirmation-label {
        text-align: center;
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .lock-icon {
        font-weight: normal;
        font-size: 17px !important;
        margin-bottom: 6px;
    }

    .periodo-wide {
        position: absolute;
        top: 218px !important;
        margin-left: 10px;
        width: 163px !important;
    }
</style>
